import React, { useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../App';
import { useEvents } from '../hooks/useEvents';
import EventCard from '../components/events/EventCard';
import { useIsDesktop } from '../hooks/useIsDesktop';
import PageHeader from '../components/common/PageHeader';
import { SPORT_CATEGORY } from '../utils/eventCategories';

export default function EventDetails() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { currentUser, blockedIds } = useContext(UserContext);
    const isDesktop = useIsDesktop();

    // Retrieve events. Realtime updates will flow in naturally through this hook.
    const { data, isLoading, error, refetch } = useEvents(currentUser?.id, blockedIds, { includeCancelled: true });

    if (isLoading) return <div style={{ padding: '20px', textAlign: 'center', marginTop: '60px' }}>載入中...</div>;
    if (error || !data) return <div style={{ padding: '20px', textAlign: 'center', marginTop: '60px' }}>發生錯誤</div>;

    // UUID or string integer fallback match
    const event = data.events.find(e => e._id === id || e.id === id);

    if (!event) return <div style={{ padding: '40px', textAlign: 'center', marginTop: '60px' }}>找不到該活動</div>;

    return (
        <div style={{ background: 'linear-gradient(180deg, #eef4f9 0%, #f7f9fc 24%, #ffffff 100%)', minHeight: '100vh', paddingBottom: '40px' }}>
            <PageHeader title={event.category === SPORT_CATEGORY ? '運動揪團詳情' : '活動詳情'} subtitle={event.title} backLabel={event.category === SPORT_CATEGORY ? '返回揪運動列表' : '返回揪活動列表'} onBack={() => navigate(event.category === SPORT_CATEGORY ? '/sports' : '/events')} maxWidth={1100} />

            <div style={{ maxWidth: isDesktop ? '1100px' : '800px', margin: '0 auto' }}>
                <div style={{ padding: isDesktop ? '24px 32px' : '16px 16px 24px' }}>
                    <EventCard
                        event={event}
                        currentUserId={currentUser?.id || currentUser?._id}
                        userFavorites={data.userFavorites || []}
                        isDetailsPage={true}
                        onEventEdit={(evt) => navigate(evt.category === SPORT_CATEGORY ? `/sports/${evt._id || evt.id}/edit` : `/events/${evt._id || evt.id}/edit`)}
                        onJoin={() => refetch && refetch()}
                        onFavoriteToggle={() => refetch && refetch()}
                        onEventCancel={() => refetch && refetch()}
                        onEventLeave={() => refetch && refetch()}
                        onParticipantStatusChange={() => refetch && refetch()}
                    />
                </div>
            </div>
        </div>
    );
}
